import TitleBlock from '@anm/components/TitleBlock';
import Button from '@anm/components/buttons/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import CardModal, { CardModalContent } from '@anm/components/modals/CardModal';
import styled, { css } from 'styled-components';

export const ModalWrapper = styled(CardModal)`
  text-align: center;
  max-width: 480px;

  ${CardModalContent} {
    padding: 28px 40px;
  }
`;

export const ModalTitle = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h3,
  h4,
  h5,
  h6 {
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: ${({ theme }) => theme.textColor};
  }
`;

export const ModalTextWrapper = styled.p`
  margin: 12px 0 0 0;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  max-width: 400px;
  color: ${({ theme }) => theme.textColor};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

const commonButtonStyles = css`
  height: 50px;
  line-height: 48px;
  font-size: 16px;
  text-align: center;
`;

export const CancelButton = styled(Button)`
  ${commonButtonStyles};
  color: #30aef2;
  min-width: 117px;
  margin-right: 10px;
`;

export const ConnectButton = styled(ButtonLoader)`
  ${commonButtonStyles};
  min-width: 129px;
  color: #fff;
`;
